const template = require('./textViewer.template');
const TuiEditor = require('tui-editor');
require('./textViewer.styles');

import { Action } from 'util/domain';
import { CommonUtilsService } from 'util/services/commonUtilsService';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { AppAction } from 'sharebase-app/components/_app/app.actions';
import { DocumentAction } from 'sharebase-app/components/documentView/documentView.actions';
import { ActionRepository } from 'sharebase/services/actionRepository';
import { MenuPriority } from 'sharebase/domain';
import { 
	PendingActionsService, 
	PendingActionScope 
} from 'sharebase/services/pendingActionsService';

interface TextViewerScope extends ng.IScope {
	vm: TextViewerController
} 

export function TextViewerDirective():ng.IDirective{
	return {
		restrict: 'E',
		controller: TextViewerController,
		template,
		controllerAs: 'vm',
		bindToController: true,
		scope: {
			initialContent: '<content',
			canEdit: '<?',
			onSave: '&?'
		},
		link: (scope:TextViewerScope, element:ng.IAugmentedJQuery, attrs) => {
			let editorElement = element[0].querySelector('.content-area');
			let editor;
			
			scope.$watch('vm.initialContent', (newVal:string, oldVal:string) => {
				if(!angular.isDefined(newVal)){
					return;
				}
			
				if(editor){
					editor.remove();
					editor = null;
				}

				editor = new TuiEditor({
					el: editorElement,
					initialEditType: 'wysiwyg',
					viewer: !scope.vm.canEdit,
					initialValue: scope.vm.content,
					previewStyle: 'vertical',
					height: '100%'
				});
				editor.focus();
				editor.on('change', (arg) => {
					scope.vm.content = editor.getMarkdown();
				});
			});

			scope.$on('$destroy', () => {
				editor = null;
				scope.vm.removeSubscriptions();
			});
		}
	}
}

TextViewerDirective.$inject = [
];

interface SavePayload{
	content:string;
}
class TextViewerController {
	public static $inject = [
		'utils',
		'sbActionRepository',
		'sbPendingActionsService',
		'sbaToolbarService',
		'gettextCatalog'
	];
	
	public canEdit:boolean = angular.isDefined(this.canEdit) ? this.canEdit : false;	
	public get modified(){
		return this.lastHash !== this.lastSavedHashed;
	}
	public get content(){
		return this._content || this.initialContent;
	}
	public set content(val){
		if(!angular.isDefined(val) || val === this.content){
			return;
		}

		// calculate original hash on first write
		if(!this.lastSavedHashed){
			this.lastSavedHashed = this.utils.generateHash(this.initialContent);
		}

		this._content = val;
		this.lastHash = this.utils.generateHash(val);
		
		if(this.modified){
			if(!this.pendingAction){
				let msg = this.gettextCatalog.getString('There are unsaved changes to this document.');
				this.pendingAction = this.sbPendingActionsService
					.addMessage(msg, 'Document viewer', PendingActionScope.All);
			}
		}
		else {			
			// it's possible the document could have been edited back into
			// a state identical to its last saved state, so don't alert user
			if(this.pendingAction){
				this.pendingAction();
				this.pendingAction = null;
			}
		}
	}	


	private _content:string;
	private initialContent:string;
	private lastHash:string;
	private lastSavedHashed:string;
	private pendingAction:Action;
	private unsubs:Action[] = [];
	private onSave:(data:SavePayload) => void;

	constructor(
		private utils:CommonUtilsService,
		private sbActionRepository:ActionRepository,
		private sbPendingActionsService:PendingActionsService,
		private sbaToolbarService:ToolbarService,
		private gettextCatalog:ng.gettext.gettextCatalog
	){
		this.setToolbarItems();
	}


	private setToolbarItems(){
		this.unsubs.push(...this.sbaToolbarService
			.getItems(
				AppAction.EditInShareBaseDesktop,
				AppAction.Replace
			)
			.map(i => i.addValidator(() => false))
		);

		if(angular.isDefined(this.onSave)){
			let saveItem = this.sbActionRepository.createFromActionName(DocumentAction.Save, true, false);
			saveItem.addTrigger(() => this.save());
			this.unsubs.push(
				this.sbaToolbarService.addItem(saveItem, MenuPriority.HIGH)
			);
		}
	}

	public removeSubscriptions(){
		this.unsubs.forEach(unsub => unsub());
	}

	public save() {
		if(this.pendingAction){
			this.pendingAction();
			this.pendingAction = null;
		}		

		if(this.onSave && this.modified){
			this.onSave({
				content: this.content
			});
		}
		this.lastSavedHashed = this.utils.generateHash(this.content);
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/components/textViewer/textViewer.ts